import { Dispatch } from "redux";
import {JackpotsAction, JackpotsActionTypes} from "../../types/Jackpot/jackpotsTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getJackpotsData = (): any => {
    return async (dispatch: Dispatch<JackpotsAction>) => {
        try {
            dispatch({ type: JackpotsActionTypes.FETCH_JACKPOTS_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/jackpot_cards`,
                withCredentials: false
            });
            dispatch({ type: JackpotsActionTypes.FETCH_JACKPOTS_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: JackpotsActionTypes.FETCH_JACKPOTS_DATA_ERROR, payload: errorPayload });
        }
    }
}
